import {Route, Routes} from 'react-router-dom';
import {HistorySentMail} from './lich-su-gui-mail';

export const System = () =>{

  return(
    <Routes>
      <Route path="lich-su-gui-mail" element={<HistorySentMail/>}/>
    </Routes>
  )
}